import { FaStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
const OtherHonorableMentions = ({ data }) => {
  const navigate = useNavigate();

  const casinos = data.map((c) => ({
    id: c.id,
    name: c.name,
    rating: c.rating,
    imageUrl: c.image,
    bestFor: c.bestFor,
    welcomeOffer: c.welcomeOffer,
    casinoUrl: c.casinoUrl,
  }));

  if (!casinos.length) return null;

  return (
    <section className="bg-background dark:bg-gray-900 text-black dark:text-white py-16 transition-colors duration-300">
      <div className="w-full mx-auto max-w-[1000px] px-6">
        {/* Header */}
        <h2 className="text-xl sm:text-2xl font-bold mb-8 text-text dark:text-white">
          Other honorable mentions
        </h2>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {casinos.map((casino) => (
            <div
              key={casino.id}
              className="rounded-xl border border-border dark:border-gray-700 bg-surface dark:bg-gray-800 p-4 sm:p-6 shadow-sm transition-colors duration-300"
            >
              {/* Header */}
              <div className="flex items-center gap-4">
                {/* Logo */}
                <div className=" !w-[180px] rounded-lg overflow-hidden bg-black/90 dark:bg-white/10 flex items-center justify-center   dark:shadow-[0_0_15px_3px_rgba(156,163,175,0.3)] ">
                  <img
                    src={casino.imageUrl}
                    alt={casino.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex flex-col justify-start">
                  <h3 className="text-lg font-semibold text-text dark:text-white">
                    {casino.name}
                  </h3>
                  <div className="mt-1 inline-flex items-center gap-1.5 h-7 rounded-md border border-border dark:border-gray-700 bg-surface dark:bg-gray-700 px-2.5 text-[13px] leading-none transition-colors duration-300">
                    <FaStar className="h-3.5 w-3.5 text-amber-500" />
                    <span className="font-semibold text-text dark:text-white">
                      {casino.rating}
                    </span>
                    <span className="opacity-80 text-text/70 dark:text-white/60">
                      /5
                    </span>
                  </div>
                </div>
              </div>

              {/* Review Button */}
              <div className="mt-4">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!casino?.name) return;
                    const slug = casino.name.toLowerCase().replace(/\s+/g, "-");
                    navigate(`/${slug}-review`, { state: { casino } });
                  }}
                  type="button"
                  className="w-full inline-flex items-center justify-center rounded-lg border border-border dark:border-gray-700 bg-surface dark:bg-gray-700 px-3.5 py-2 text-sm font-medium text-text dark:text-white hover:bg-primary/10 dark:hover:bg-primary/20 transition-colors duration-300"
                >
                  {casino.name} Review
                </button>
              </div>

              {/* Good for */}
              <div className="mt-4 text-left">
                <div className="text-[12px] text-text/70 dark:text-white/60 mb-1">
                  Good for
                </div>
                <div className="text-sm font-medium text-text dark:text-white">
                  {casino.bestFor}
                </div>
              </div>

              {/* Offer */}
              <div className="mt-4 text-left">
                <div className="text-[12px] text-text/70 dark:text-white/60 mb-1">
                  Sign up offer
                </div>
                <div className="text-base font-semibold leading-snug text-text dark:text-white">
                  {casino.welcomeOffer}
                </div>
              </div>

              {/* Claim Bonus */}
              <div className="mt-5">
                <motion.button
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (casino?.casinoUrl) {
                      window.open(
                        casino.casinoUrl,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }
                  }}
                  onMouseDown={(e) => e.stopPropagation()}
                  className="w-full inline-flex items-center justify-center h-10 px-4 rounded-lg bg-primary text-white font-semibold shadow-sm hover:bg-primary-hover transition border-0"
                >
                  <span>Claim Bonus</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-2 h-4 w-4 -mt-px"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M7 17L17 7M9 7h8v8"
                    />
                  </svg>
                </motion.button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OtherHonorableMentions;
